import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ClientsAddress from '../../models/ClientsAddress'
import { Button, Grid, Header, Icon, List, Table } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

class AddressEquipment extends Component {
  static propTypes = {
    clientAddress: PropTypes.instanceOf(ClientsAddress).isRequired,
    clientId: PropTypes.number.isRequired,
    clientAddressEquipementId: PropTypes.number,
    canEdit: PropTypes.bool.isRequired,
    canSelect: PropTypes.bool,
    handleSelect: PropTypes.func
  }

  defaultTypes = {
    canSelect: false
  }

  render () {
    const { canEdit, clientAddress, clientId, canSelect, handleSelect, clientAddressEquipementId } = this.props
    // eslint-disable-next-line camelcase
    const { address, clients_addresses_equipments, id } = clientAddress
    return (
      <>
        <Grid.Row id={id}>
          <Grid.Column verticalAlign='middle'>
            <List>
              <List.Item>
                <Header as='h3' floated='left'>{address.fullAddress}</Header>
              </List.Item>
              {canEdit &&
                <List.Item>
                  <Button icon as={Link} to={`/clients/inspections-addresses/edit/${clientId}/${id}`}>
                    <Icon
                      name='pencil'
                    /> Modifier adresse
                  </Button>
                </List.Item>}
            </List>
          </Grid.Column>
        </Grid.Row>
        {canEdit &&
          <Grid.Row>
            <Grid.Column>
              <List horizontal>
                <List.Item>
                  <Button icon as={Link} primary to={`/clients/inspections-addresses-equipment/create/${id}`}>
                    <Icon
                      name='plus'
                    /> Ajouter un équipement
                  </Button>
                </List.Item>
                <List.Item>
                  <Button icon as={Link} primary to={`/events/create/${clientId}?clientAddressId=${id}`}>
                    <Icon
                      name='calendar plus'
                    /> Ajouter une inspection
                  </Button>
                </List.Item>
              </List>
            </Grid.Column>
          </Grid.Row>}
        <Grid.Row>
          <Grid.Column>
            <Table celled>
              <Table.Header key='header'>
                <Table.Row>
                  <Table.HeaderCell>Équipement</Table.HeaderCell>
                  <Table.HeaderCell>Formulaires</Table.HeaderCell>
                  <Table.HeaderCell>Fréquence d'inspection</Table.HeaderCell>
                  <Table.HeaderCell>Dernière inspection</Table.HeaderCell>
                  <Table.HeaderCell>Prochaine inspection</Table.HeaderCell>
                  {(canEdit || canSelect) && <Table.HeaderCell>Actions</Table.HeaderCell>}
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {clients_addresses_equipments.filter(clientsAddressesEquipment => !clientAddressEquipementId || (clientsAddressesEquipment.id === clientAddressEquipementId))
                  .map(clientsAddressesEquipment => {
                    return (
                      <Table.Row key={clientsAddressesEquipment.id}>
                        <Table.Cell>
                          {canEdit
                            ? (
                              <Link to={`/clients/inspections-addresses-equipment/edit/${clientsAddressesEquipment.id}`}>
                                {clientsAddressesEquipment.equipment.name}
                              </Link>)
                            : clientsAddressesEquipment.equipment.name}
                        </Table.Cell>
                        <Table.Cell>{clientsAddressesEquipment.forms.join(', ')}</Table.Cell>
                        <Table.Cell>{clientsAddressesEquipment.inspectionFrequency}</Table.Cell>
                        <Table.Cell>{clientsAddressesEquipment.lastInspectionDate}</Table.Cell>
                        <Table.Cell>{clientsAddressesEquipment.nextInspectionDate}</Table.Cell>
                        {canEdit && <Table.Cell><Link to={`/events/create/${clientId}/${clientAddress.id}/${clientsAddressesEquipment.id}`}><Icon link name='file' /></Link></Table.Cell>}
                        {canSelect &&
                          <Table.Cell>
                            <Button
                              primary onClick={() => {
                                if (handleSelect) { handleSelect(clientAddress.id, clientsAddressesEquipment.id) }
                              }}
                            >Select
                            </Button>
                          </Table.Cell>}
                      </Table.Row>
                    )
                  })}
                {!clients_addresses_equipments.length && (
                  <Table.Row>
                    <Table.Cell width={5}>
                      Aucun équipement enregistré à cette adresse
                    </Table.Cell>
                  </Table.Row>)}
              </Table.Body>
            </Table>
          </Grid.Column>
        </Grid.Row>
      </>
    )
  }
}

export default AddressEquipment
